import { Head, Link, usePage } from "@inertiajs/react"
import { useIntl } from "react-intl"
import { AppShell } from "@/components/AppShell"
import { AuthShell } from "@/components/AuthShell"
import { Button } from "@/components/ui/button"
import type { PageProps } from "@/types/inertia"

const MESSAGES: Record<number, { title: { id: string }; body: { id: string } }> = {
  400: { title: { id: "error.k400_title" }, body: { id: "error.k400_body" } },
  404: { title: { id: "error.k404_title" }, body: { id: "error.k404_body" } },
  422: { title: { id: "error.k422_title" }, body: { id: "error.k422_body" } },
  500: { title: { id: "error.k500_title" }, body: { id: "error.k500_body" } },
}

export default function ErrorPage({ status }: { status: number }) {
  const intl = useIntl()
  const { props } = usePage<PageProps>()
  const signedIn = !!props.current_user
  const messages = MESSAGES[status] ?? MESSAGES[500]
  const title = intl.formatMessage(messages.title)
  const body = intl.formatMessage(messages.body)

  const content = (
    <div className="text-center">
      <p className="text-sm text-ink-muted">{intl.formatMessage({ id: "error.label" }, { status })}</p>
      <h1 className="mt-2">{title}</h1>
      <p className="mt-2">{body}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
        <Button asChild>
          <Link href={signedIn ? "/dashboard" : "/"}>{signedIn ? intl.formatMessage({ id: "error.go_dashboard" }) : intl.formatMessage({ id: "error.go_home" })}</Link>
        </Button>
        <Button type="button" variant="secondary" onClick={() => window.history.back()}>
          {intl.formatMessage({ id: "error.go_back" })}
        </Button>
      </div>
    </div>
  )

  return (
    <>
      <Head title={title}>
        <meta name="robots" content="noindex" />
        <meta name="description" content={body} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={body} />
      </Head>
      {signedIn ? (
        <AppShell>
          <div className="mx-auto mt-16 max-w-md">{content}</div>
        </AppShell>
      ) : (
        <AuthShell>{content}</AuthShell>
      )}
    </>
  )
}
